import { useQuery } from '@tanstack/react-query';

import { type Camera } from 'src/features/cameras/types/camera';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';

import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/cameras/';

interface Query extends ListDTO {
    parkingId: string;
}

type CameraQueryFnType = typeof getCameras;

interface UseCameraOptions extends Query {
    config?: QueryConfig<CameraQueryFnType>;
}

export const getCameras = ({ parkingId, ...params }: Query): Promise<ListResponseSmartParkAPI<Camera>> => {
    return axios.get(RESOURCE.replace(':parkingId', parkingId), { params });
};

export const useGetCameras = ({ config, ...params }: UseCameraOptions) =>
    useQuery({
        queryKey: [RESOURCE, ...Object.values(params)],
        queryFn: async () => await getCameras(params),
        ...config,
    });
